import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/lodging/getList',
        method: 'post',
        data: data
    })
}
export function createUpdate(data) {
    return request({
        url: '/backend/lodging/createUpdate',
        method: 'post',
        data: data
    })
}
export function getDetail(data) {
    return request({
        url: '/backend/lodging/getDetail',
        method: 'post',
        data: data
    })
}
export function del(data) {
    return request({
        url: '/backend/lodging/delete',
        method: 'post',
        data: data
    })
}
export function updateStatus(data) {
    return request({
        url: '/backend/lodging/updateStatus',
        method: 'post',
        data: data
    })
}
export function setInfoField (data) {
    return request({
        url: '/backend/lodging/setInfoField',
        method: 'post',
        data: data
    })
}
export function getLodgingURL (data) {
    return request({
        url: '/backend/lodging/getLodgingURL',
        method: 'post',
        data: data
    })
}

export function getItemList (data) {
    return request({
        url: '/backend/lodging/getItemList',
        method: 'post',
        data: data
    })
}
export function createUpdateItem (data) {
    return request({
        url: '/backend/lodging/createUpdateItem',
        method: 'post',
        data: data
    })
}

export function deleteItem (data) {
    return request({
        url: '/backend/lodging/deleteItem',
        method: 'post',
        data: data
    })
}
export function updateItemFire (data) {
    return request({
        url: '/backend/lodging/updateItemFire',
        method: 'post',
        data: data
    })
}
export function updateItemSort (data) {
    return request({
        url: '/backend/lodging/updateItemSort',
        method: 'post',
        data: data
    })
}
export function getLodgingTitle (data) {
    return request({
        url: '/backend/lodging/getLodgingTitle',
        method: 'post',
        data: data
    })
}
export function getLodgingItemTitleList (data) {
    return request({
        url: '/backend/lodging/getLodgingItemTitleList',
        method: 'post',
        data: data
    })
}